import React, {Fragment, useContext, useEffect} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {useRenderableData} from "../common/hooks/useRenderableData";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {SubscriptionDetail} from "./SubscriptionDetail";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {GlobalContext} from "../admin-frame/AdminFrame";

export let UpdateSubscription = function (props) {
    const context = useContext(GlobalContext);
    const renderableData = useRenderableData({loading: true});

    // on mount, fetch subscription from API and put it in state
    useEffect(function () {
        let dataUpdate = {};
        renderableData.updateAndRender({loading: true})
        ApiUtility.getSubscription(props.subscriptionId)
            .then(function (subscription) {
                dataUpdate = {
                    subscription: subscription,
                    loading: false,
                }
                return ApiUtility.getDefaultInvoiceSettingsUrl()
            })
            .then(function (urlResponse) {
                dataUpdate.invoiceDefaultsUrl = urlResponse.url
                renderableData.updateAndRender(
                    dataUpdate
                );
            })
            .catch(function (error) {
                renderableData.updateAndRender({loading: false});
                console.log(`Error fetching subscription: `, error);
                MessageDisplayerUtility.error(`Error fetching subscription.`);
            });
    }, [props.subscriptionId]);

    function onClickSync() {
        renderableData.updateAndRender({loading: true})
        ApiUtility.syncSubscriptionInvoices(props.subscriptionId)
            .then((response) => {
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                MessageDisplayerUtility.success(`Successfully synced subscription invoices.`);
                props.afterSuccessfulSave(props.subscriptionId)
            })
            .catch((err) => {
                renderableData.updateAndRender({loading: false});
                console && console.error(err);
                MessageDisplayerUtility.error(`An error occurred while syncing the subscription invoices.`);
            });
    }

    return (
        <Fragment>
            <ConditionalRenderer if={renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={renderableData.subscription} renderer={() => (
                <SubscriptionDetail
                    cancel={props.cancel}
                    subscription={renderableData.subscription}
                    invoiceDefaultsUrl={renderableData.invoiceDefaultsUrl}
                    onClickSync={onClickSync}
                    onClickInvoice={props.onClickInvoice}
                />
            )}/>
        </Fragment>
    );
};
